<template>
	<div>
		<Titlebar />
		<router-view />
	</div>
</template>

<script>
import Titlebar from '@/components/Titlebar'

export default {
	name: 'Competitions',
	components: {
		Titlebar,
	},
}
</script>
